module.exports = __webpack_public_path__ + "img/gsb8.cc82ee20.png";